import { render } from "./Bio.vue?vue&type=template&id=4b9ebaed&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"

import "./Bio.vue?vue&type=style&index=0&id=4b9ebaed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9ebaed"]])

export default __exports__